import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFormInfo, ILeadPayload, TFields } from '../form-fileds.model';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  ApiService,
  AuthService,
  EventsService,
  UtilService,
  VariablesService,
} from 'src/app/shared/services';
import { NgoSelectComponent } from '../../ngo-select/ngo-select.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MeilisearchInputComponent } from '../../meilisearch-input/meilisearch-input.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EditorModule } from 'src/app/common/editor/editor.module';
// import { ImageVideoUploadComponent } from '../../image-video-upload/image-video-upload.component';
import { environment } from 'src/environments/environment';
import { IUser } from 'src/app/shared/models';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { OtpInputComponent } from '../../otp-input/otp-input.component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SearchSelectComponent } from '../../search-select/search-select.component';
import { MediaUploadComponent } from '../../image-video-uploadV2/image-video-uploadV2.component';
import { strippedLengthValidator } from './validator';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatRippleModule,
    NgoSelectComponent,
    MeilisearchInputComponent,
    MatCheckboxModule,
    EditorModule,
    // ImageVideoUploadComponent,
    MediaUploadComponent,
    MatDialogModule,
    MatIconModule,
    OtpInputComponent,
    SearchSelectComponent
  ],
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent {
  private readonly api = inject(ApiService);
  private readonly auth = inject(AuthService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly events = inject(EventsService);
  private readonly dialog = inject(MatDialog);
  private readonly sheet = inject(MatBottomSheet);
  private readonly util = inject(UtilService);
  readonly vars = inject(VariablesService);

  @ViewChild('verifyDialogTemplate', { static: true }) verifyDialogTemplate: TemplateRef<any>;
  @ViewChild('emailOTPDialogTemplate', { static: true }) emailOTPDialogTemplate: TemplateRef<any>;

  @Input() formInfo!: IFormInfo;
  @Input() otherInfo: any;
  @Input() draftData!: any;
  @Input() buttonLabels!: any;
  @Output() onChange = new EventEmitter<any>();
  @Output() startFundraiser = new EventEmitter<any>();
  @Output() createCampaign = new EventEmitter<any>();
  @Output() sendLead = new EventEmitter<ILeadPayload>();

  formFields: Record<TFields, FormControl<any>> = {
    name: new FormControl('', [Validators.required, Validators.pattern(this.vars.name_Pattern_Regex), Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.vars.email_Pattern_Regex)]),
    raisingFor: new FormControl('', Validators.required),
    ngo: new FormControl('', Validators.required),
    relation: new FormControl('', Validators.required),
    beneficiaryName: new FormControl('', [Validators.required, Validators.pattern(this.vars.name_Pattern_Regex), Validators.minLength(3)]),
    age: new FormControl('', Validators.required),
    fundRequired: new FormControl('', [Validators.required, Validators.min(2000), Validators.max(50000000)]),
    cause: new FormControl('', Validators.required),
    ailment: new FormControl('', Validators.required),
    hospitalisation: new FormControl('', Validators.required),
    hospital: new FormControl('', Validators.required),
    sameCityAsHospital: new FormControl(true),
    city: new FormControl('', Validators.required),
    title: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(75)]),
    about: new FormControl('', [Validators.required, strippedLengthValidator(50)]),
    aboutMerge: new FormControl('', Validators.required),
    media: new FormControl(''),
    insuranceOptIn: new FormControl(true),
    agree: new FormControl(false, Validators.requiredTrue)
  };

  formGroup: FormGroup = new FormGroup({
    name: this.formFields.name,
    email: this.formFields.email,
    raisingFor: this.formFields.raisingFor,
  });

  emailOtpControl = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
  otpFormGroup: FormGroup = new FormGroup({
    otp: this.emailOtpControl
  });

  initFields: TFields[] = ['name', 'email', 'raisingFor'];

  isCauseLoading = false;
  showList = false;
  causeList: any[] = [];
  formData: any;
  mergedCauseList: any[] = [];
  showReviewDock: boolean = false;
  showRedirectNGO: boolean = false;
  isFinalStep = false;
  userData: IUser;
  firebaseRes;
  dialogRef: MatDialogRef<any>;
  dialogRefEmailOtp: MatDialogRef<any>;
  sheetRefEmailOtp: MatBottomSheetRef<any>;
  showFullLoader = false;
  alreadyExistEmails = [];
  causeName = '';

  ngOnInit() {
    this.firebaseRes = this.util.storage.getFromSession('firebasePhoneData');
    this.userData = this.vars.userData.getValue();
    this.vars.userData.subscribe(u => {
      if (u) {
        this.userData = u;
        this.formFields.name.setValue(this.userData.full_name);
        this.formFields.email.setValue(this.userData.email);
        this.formFields.name.disable();
        this.formFields.email.disable();
      }
    });
    this.subscribeAllControls();
    this.getMergedCauses();
  }

  async prefill(draftData: any) {
    this.formData = draftData;
    this.causeName = draftData?.causeName;
    if (this.formData) {
      Object.entries(this.formData).forEach(([key, value]) => {
        if (value) {
          if (key === 'ngo' && this.formData?.raisingFor === 'ngo' && !this.isFinalStep) {
            this.onNgoSelect(key, {option: value, value: value});
          } else if (key in this.formFields && value) {
            Promise.resolve().then(() => {
              this.formFields[key].setValue(value);
              if (['raisingFor'].includes(key)) {
                this.formFields[key].disable();
              }
            });
          }
        }
      });
    }
    setTimeout(() => {
      this.onChange.emit({ formData: this.formGroup.getRawValue(), formGroup: this.formGroup, causeName: this.causeName });
      // this.util.storage.checkFromSession('safForm', this.formGroup.getRawValue());
    }, 1000);
  }

  resetFormGroup(raisingFor = this.formFields.raisingFor.value) {
    const remove: TFields[] = [];
    Object.keys(this.formFields).forEach((k: TFields) => {
      if (!(['name', 'email', 'raisingFor'].includes(k) || (raisingFor === 'self' && k === 'age') || (raisingFor === 'someoneElse' && k === 'relation') || (raisingFor === 'ngo' && k === 'ngo'))) {
        remove.push(k);
      }
    });
    this.addRemoveControl(remove, 'remove');
  }

  subscribeAllControls() {
    Object.keys(this.formFields).forEach((key: TFields) => {
      this.formFields[key].valueChanges.subscribe((val) => {
        this.onValueChange(key, val);
        if (key === 'raisingFor') {
          this.resetFormGroup();
        }
        if (key === 'sameCityAsHospital') {
          this.rebuildGroup(key);
        }
        if (key === 'agree' || key === 'insuranceOptIn') {
          this.cdr.detectChanges();
        }
      });
    });
  }

  onValueChange(key: TFields, val) {
    if (this.formData) {
      this.formData[key] = val;
    }
    if(key === 'sameCityAsHospital' && !val) {
      this.formFields.city.setValue(this.formFields.hospital.value?.city || '');
      this.formFields.city.markAsUntouched();
      this.formFields.city.markAsPristine();
      this.formFields.city.setErrors(null);
    }
    setTimeout(() => {
      this.rebuildGroup(key);
    }, 0);
    setTimeout(() => {
      this.onChange.emit({
        key: key,
        formData: this.formGroup.getRawValue(),
        formGroup: this.formGroup,
        causeName: this.causeName
      });
      this.util.storage.checkFromSession('safForm', this.formGroup.getRawValue());
    }, 500);
  }

  getFormValidationErrors(formGroup: FormGroup): Record<string, any> {
    const errors: Record<string, any> = {};
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        const childErrors = this.getFormValidationErrors(control);
        if (Object.keys(childErrors).length > 0) {
          errors[key] = childErrors;
        }
      } else if (control?.errors) {
        errors[key] = control.errors;
      }
    });
    return errors;
  }


  rebuildGroup(key: TFields) {
    if (this.formFields.name.invalid || this.formFields.email.invalid || this.formFields.raisingFor.invalid) return;
    setTimeout(() => {
      this.showHideFields();
    }, 10);
  }

  showHideFields() {
    const formValues = Object.keys(this.formFields).reduce((acc, key: TFields) => {
      acc[key] = this.formFields[key].value;
      return acc;
    }, {} as Record<TFields, any>);
    const { about, aboutMerge, age, agree, ailment, beneficiaryName, cause, city, email, relation, fundRequired, hospital, hospitalisation, media, ngo, raisingFor, title } = formValues;

    this.showReviewDock = false;
    const removeFields: TFields[] = [];
    const addFields: TFields[] = [];
    if (this.formFields.name.invalid || this.formFields.email.invalid) {
      this.removeFormValues(['name', 'email', 'raisingFor']);
      return;
    }

    if (raisingFor === 'self') {
      this.causeList = this.mergedCauseList;
      removeFields.push('relation');
      addFields.push('age');
      if (age) {
        addFields.push('fundRequired');
        addFields.push('cause');
      } else {
        removeFields.push('fundRequired');
        removeFields.push('cause');
      }
      if (cause == 59 && fundRequired) {
        addFields.push('ailment');
        addFields.push('hospitalisation');
        if (hospitalisation === 'Does not require hospitalisation') {
          addFields.push('city');
          removeFields.push('hospital');
          removeFields.push('sameCityAsHospital');
          if (city) {
            this.showReviewDock = true;
          }
        } else if (hospitalisation) {
          addFields.push('hospital');
          if (hospital) {
            if (hospital.city) {
              addFields.push('sameCityAsHospital');
              if (this.formFields.sameCityAsHospital.value) {
                removeFields.push('city');
                this.showReviewDock = true;
              } else {
                addFields.push('city');
              }
            } else {
              removeFields.push('sameCityAsHospital');
              addFields.push('city');
            }
            if (city) {
              this.showReviewDock = true;
            }
          } else {
            removeFields.push('city');
            removeFields.push('sameCityAsHospital');
          }
        }
      } else if (cause && fundRequired) {
        addFields.push('city');
        removeFields.push('ailment');
        removeFields.push('hospitalisation');
        removeFields.push('hospital');
        if (city) {
          this.showReviewDock = true;
        }
      } else if (!(cause && fundRequired)) {
        removeFields.push('ailment');
        removeFields.push('hospitalisation');
        removeFields.push('hospital');
        removeFields.push('city');
      }
    }

    if (raisingFor === 'someoneElse') {
      this.causeList = this.mergedCauseList;
      addFields.push('relation');
      if (relation) {
        if (relation === 'Pet') {
          addFields.push('fundRequired');
          removeFields.push('age');
          removeFields.push('ailment');
          removeFields.push('hospitalisation');
          removeFields.push('hospital');
          removeFields.push('cause');
          if (this.formFields.fundRequired.valid) {
            addFields.push('city');
            if (city) {
              this.showReviewDock = true;
            }
          } else {
            removeFields.push('city');
          }
        } else {
          addFields.push('beneficiaryName');
          if (beneficiaryName) {
            addFields.push('age');
            if (age) {
              addFields.push('fundRequired');
              addFields.push('cause');
            } else {
              removeFields.push('fundRequired');
              removeFields.push('cause');
            }
          } else {
            removeFields.push('age');
          }
          if (cause == 59 && fundRequired) {
            addFields.push('ailment');
            addFields.push('hospitalisation');
            if (hospitalisation === 'Does not require hospitalisation') {
              addFields.push('city');
              removeFields.push('hospital');
              removeFields.push('sameCityAsHospital');
              if (city) {
                this.showReviewDock = true;
              }
            } else if (hospitalisation) {
              addFields.push('hospital');
              if (hospital) {
                if (hospital.city) {
                  addFields.push('sameCityAsHospital');
                  if (this.formFields.sameCityAsHospital.value) {
                    removeFields.push('city');
                    this.showReviewDock = true;
                  } else {
                    addFields.push('city');
                  }
                } else {
                  removeFields.push('sameCityAsHospital');
                  addFields.push('city');
                }
                if (city) {
                  this.showReviewDock = true;
                }
              } else {
                removeFields.push('city');
                removeFields.push('sameCityAsHospital');
              }
            }
          } else if (cause && fundRequired) {
            addFields.push('city');
            removeFields.push('ailment');
            removeFields.push('hospitalisation');
            removeFields.push('hospital');
            if (city) {
              this.showReviewDock = true;
            }
          } else if (!(cause && fundRequired)) {
            removeFields.push('ailment');
            removeFields.push('hospitalisation');
            removeFields.push('hospital');
            removeFields.push('city');
          }
        }
      } else {
        removeFields.push('age');
        removeFields.push('ailment');
        removeFields.push('hospitalisation');
        removeFields.push('hospital');
        removeFields.push('fundRequired');
        removeFields.push('cause');
      }
      this.addRemoveControl(removeFields, 'remove');
      this.addRemoveControl(addFields);
    }

    if (raisingFor === 'ngo') {
      addFields.push('ngo');
      if (ngo) {
        addFields.push('fundRequired');
        addFields.push('cause');
        if (fundRequired && cause) {
          this.showReviewDock = true;
        }
      } else {
        removeFields.push('fundRequired');
        removeFields.push('cause');
      }
    }

    setTimeout(() => {
      this.addRemoveControl(removeFields, 'remove');
      this.addRemoveControl(addFields);
    }, 100);

  }

  removeFormValues(except: TFields[] = []) {
    Object.keys(this.formFields).forEach((key: TFields) => {
      if (!except.includes(key)) {
        this.formFields[key].setValue('');
        this.addRemoveControl([key], 'remove');
      }
    });
  }

  addRemoveControl(fields: TFields[], action: 'add' | 'remove' = 'add', resetValue: boolean = false) {
    fields.forEach(key => {
      if (action === 'add' && !this.formGroup.get(key)) {
        this.formGroup.addControl(key, this.formFields[key]);
      } else if (action === 'remove' && this.formGroup.get(key)) {
        this.formGroup.removeControl(key);
        if (resetValue) {
          this.formFields[key].setValue('');
        }
      }
    });
  }

  setFieldValue(key: TFields, val: any) {
    if(this.formFields.name.value === '' || this.formFields.email.value === '') return;
    if (key === "raisingFor") {
      this.causeName = "";
      this.showReviewDock = false;
      this.showRedirectNGO = false;
      this.resetSpecificFields(key, ['relation', 'beneficiaryName', 'age', 'ngo', 'fundRequired', 'cause', 'city'])
    }
    if (key === 'cause') {
      this.causeName = val?.info_1;
      val = val?.cause_id || val?.id;
      if (val === this.formFields[key].value) return;
      this.resetSpecificFields(key, ['ailment', 'hospital', 'hospitalisation', 'city'])
    }
    if (key === "hospitalisation") {
      this.resetSpecificFields(key, ['hospital', 'city'])
    }
    if (this.formFields[key].value === val) return;
    this.formFields[key].setValue(val);

    setTimeout(() => {
      this.onChange.emit({
        key: key,
        formData: this.formGroup.getRawValue(),
        formGroup: this.formGroup,
        causeName: this.causeName
      });
      this.util.storage.checkFromSession('safForm', this.formGroup.getRawValue());
    }, 500);
  }

  onCitySelect(e) {
    this.setFieldValue('city', e?.formatted_address);
    this.formFields.city.markAllAsTouched();
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 100);
  }

  onNgoSelect(key: TFields, e: any) {
    const {option, value} = e;
    this.setFieldValue(key, option || '');
    this.ngoOnBlur(value)
    if (e) {
      this.getCauses(option?.id);
      this.addRemoveControl(['fundRequired', 'cause']);
    } else {
      this.causeList = [];
      this.addRemoveControl(['fundRequired', 'cause'], 'remove');
    }
  }

  ngoOnBlur(value:string): void {
    const ngoControl = this.formGroup.get('ngo');

    if (ngoControl && value !== "" && ngoControl.invalid) {
      this.showReviewDock = true;
      this.showRedirectNGO = true;
    } else {
      this.showReviewDock = false;
      this.showRedirectNGO = false;
    }
  }

  onMeiliSelect(key: TFields, e: any) {
    if(key === 'hospital') {
      if (e.city) {
        this.formFields.sameCityAsHospital.setValue(true);
        this.formFields.city.setValue(e.city);
      }else{
        this.formFields.city.setValue('');
        this.formFields.city.markAsUntouched();
        this.formFields.city.markAsPristine();
        this.formFields.city.setErrors(null);
      }
    }
    this.setFieldValue(key, e || '');
  }

  getCauses(ngoId) {
    this.isCauseLoading = true;
    this.causeList = [];
    const url = environment.APP.API_URLS.GET_CAUSE_BY_NGO_ID(ngoId) + '?filter=full_name;id';
    this.api.get(url).subscribe({
      next: (res) => {
        this.causeList = res?.data;
        if (!this.causeList?.length) {
          this.formFields.ngo.setErrors({ custom: true });
        }
        if (this.causeList?.length && this.formFields.cause.value) {
          const cause = this.causeList.filter(v => v?.cause_id === this.formFields.cause.value)?.[0]?.cause_id || undefined;
          if (!cause) {
            this.formFields.cause.setValue('');
          }
        }
        this.isCauseLoading = false;
        this.cdr.detectChanges();
      },
      error: (res) => {
        this.isCauseLoading = false;
      },
    });
  }

  getMergedCauses() {
    this.api.get(environment.APP.API_URLS.GET_MERGED_CAUSES).subscribe({
      next: (res: any) => {
        const priorityOrder = ['medical', 'education', 'personal'];
        const mergedCauses = [
          ...(res?.data?.causes?.[0]?.child || []),
          ...(res?.data?.causes?.[1]?.child || []),
        ];
        this.mergedCauseList = mergedCauses.sort((a: any, b: any) => {
          const getPriority = (label: string) => {
            const lower = label.toLowerCase();
            const index = priorityOrder.findIndex((keyword) =>
              lower.includes(keyword)
            );
            return index !== -1 ? index : Infinity;
          };
          const aPriority = getPriority(a.info_1);
          const bPriority = getPriority(b.info_1);
          if (aPriority !== bPriority) {
            return aPriority - bPriority;
          }
          return a.info_1.localeCompare(b.info_1);
        });
        this.rebuildGroup('cause');
      },
      error: (err: any) => { },
    });
  }

  editorFocusOut(key) {
    // this.onChange.emit({
    //   key: key,
    //   value: this.formFields[key].value,
    //   fieldSets: this.fieldSets,
    // });
  }

  getInvalidFields(): string[] {
    return Object.keys(this.formGroup.controls).filter((key) => {
      const control = this.formGroup.get(key);
      return control?.invalid && control?.touched;
    });
  }

  onSubmit() {
    if (this.formGroup.valid) {
      if (this.isFinalStep) {
        this.startFundraiser.emit();
        return;
      }
      this.createCampaign.emit();
    } else {
      this.formGroup.markAllAsTouched();
      this.focusFirstInvalidField();
      // console.log('Form Data:', this.formGroup.value, this.formGroup.errors);
    }
  }

  focusFirstInvalidField() {
    const invalidFields = this.getInvalidFields();
    const invalidControl = document.getElementById(invalidFields[0] + '-input');
    if (invalidControl) {
      (invalidControl as HTMLElement).focus();
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getLabelContent(key: string): string {
    const field = this.formInfo?.[key];
    const formData = this.util.storage.getFromSession('safForm');
    const { cause, raisingFor } = formData;

    if (!field) return '';

    if (key === 'about') {
      if (raisingFor === 'ngo') {
        return field.label2 ?? field.label;
      }
      if (cause !== 59) {
        if (cause === 187) {
          return field.label2 ?? field.label;
        }
        return field.label1 ?? field.label;
      }
    }

    return field.label;
  }

  /**
 * Custom field reset with specific field targeting
 * @param parentField - The parent field that changed
 * @param fieldsToReset - Specific fields to reset (optional, uses hierarchy if not provided)
 */
  resetSpecificFields(parentField: TFields, fieldsToReset?: TFields[]): void {
    const targetFields = fieldsToReset || [];

    targetFields.forEach(field => {
      if (this.formFields[field]) {
        // Reset field value and state
        this.formFields[field].setValue('');
        this.formFields[field].markAsUntouched();
        this.formFields[field].markAsPristine();
        this.formFields[field].setErrors(null);

        // Remove from form group
        if (this.formGroup.get(field)) {
          this.formGroup.removeControl(field);
        }
      }
    });

    // Trigger form rebuild
    setTimeout(() => {
      this.showHideFields();
    }, 10);
  }

  setFinalStep() {
    const fields: TFields[] = ['title', 'about', 'agree'];
    const formData = this.util.storage.getFromSession('safForm');
    const { cause, raisingFor } = formData;

    if (raisingFor === 'ngo' || cause == 187) {
      fields.push('media');
    } else if (raisingFor !== 'ngo' && cause != 59) {
      fields.push('aboutMerge', 'media');
    }
    if (raisingFor !== 'ngo' && cause == 59 && !this.util.getUserData()?.insurance) {
      fields.push('insuranceOptIn');
    }
    this.addRemoveControl(fields, 'add');
    this.isFinalStep = true;
  }

  // For Review CTA
  reviewMethod() {
    // console.log('Review Method Called');
    if (this.formGroup.valid) {
      if ([59].includes(this.formFields.cause.value)) {
        this.formFields.title.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(150)]);
      } else {
        this.formFields.title.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(75)]);
      }
      this.formFields.title.updateValueAndValidity();
      this.createCampaign.emit();
    } else {
      this.formGroup.markAllAsTouched();
      this.focusFirstInvalidField();
      // console.log('Form Data:', this.formGroup.value, this.formGroup.errors);
    }
  }

  // For Next CTA
  redirectRegisterNGO() {
    window.open('https://survey.zohopublic.com/zs/2MB3IB', '_blank', 'noopener,noreferrer');
  }

  onInputBlur(key: TFields) {
    if (['name', 'email'].includes(key) && !this.userData) {
      if (!this.firebaseRes) { }
      const { name, email } = this.formFields;
      if (name.valid && email.valid && !this.dialogRef) {
        if (this.alreadyExistEmails.includes(email.value)) {
          this.util.openSnackBar('The email id has already been taken. Please enter different email or login', 'error')
          return;
        }
        this.dialogRef = this.dialog.open(this.verifyDialogTemplate, {
          panelClass: 'verifyPhoneDialog',
          closeOnNavigation: true,
          disableClose: true
        });
        this.dialogRef.afterClosed().subscribe(n => {
          this.dialogRef = undefined;
        });
      }
    }
  }

  confirm(): void {
    if (this.dialogRef) this.dialogRef.close();
    this.verifyEmail();
  }

  editEmail(): void {
    this.closeAllDialog();
    this.dialogRef = undefined;
    this.emailOtpControl.setValue('');
    this.emailOtpControl.markAllAsTouched();
    setTimeout(() => {
      document.getElementById('email-input')?.focus();
    }, 10);
  }

  closeAllDialog() {
    if (this.sheetRefEmailOtp) this.sheetRefEmailOtp.dismiss();
    if (this.dialogRefEmailOtp) this.dialogRefEmailOtp.close();
    if (this.dialogRef) this.dialogRef.close();
  }

  resendEmailOtp(e) {
    // this.showFullLoader = true;
    const payload = {
      email_id: this.formFields.email.value
    };
    const url = environment.APP.API_URLS.USER_DETAILS_VERIFY;
    this.util.openSnackBar('otp sent to ' + this.formFields.email.value, 'success');
    this.api.post(url, payload, 'false').subscribe({
      next: (res: any) => {
        // this.showFullLoader = false;
        // this.util.openSnackBar('otp sent to ' + this.formFields.email.value, 'success');
      },
      error: (err: any) => {
        this.showFullLoader = false;
      }
    });
  }

  verifyEmail() {
    this.showFullLoader = true;
    const payload = {
      email_id: this.formFields.email.value
    };
    const url = environment.APP.API_URLS.USER_DETAILS_VERIFY;
    this.api.post(url, payload, 'false').subscribe({
      next: (res: any) => {
        this.showFullLoader = false;
        if (res?.data?.status) {
          this.vars.loginType = 'signin';
          // this.util.openSnackBar('otp sent to ' + this.formFields.email.value, 'success');
          if (this.util.isMobile()) {
            this.sheetRefEmailOtp = this.sheet.open(this.emailOTPDialogTemplate, {
              panelClass: 'verifyEmailOTPSheet',
              closeOnNavigation: true,
              disableClose: true
            });
            this.sheetRefEmailOtp.afterDismissed().subscribe(n => {
              this.sheetRefEmailOtp = undefined;
            });
          } else {
            this.dialogRefEmailOtp = this.dialog.open(this.emailOTPDialogTemplate, {
              width: '528px',
              panelClass: 'verifyEmailOTPDialog',
              closeOnNavigation: true,
              disableClose: true
            });
            this.dialogRefEmailOtp.afterClosed().subscribe(n => {
              this.dialogRefEmailOtp = undefined;
            });
          }
          // this.verifyOtpToken();
        }
      },
      error: (err: any) => {
        if (err?.error?.message === 'Invalid details') {
          this.registerUser();
        }
        if (err?.error?.message?.match('Too many attempts')) {
          this.util.openSnackBar(err?.error?.message, 'error');
          this.editEmail();
        }
        this.showFullLoader = false;
      }
    });
  }

  verifyOtpToken() {
    if (this.emailOtpControl.invalid) {
      this.emailOtpControl.markAllAsTouched();
      return;
    }
    this.showFullLoader = true;
    const { email } = this.formFields;
    const payload = {
      email: email.value,
      email_id: email.value,
      otp: this.emailOtpControl.value
    };
    this.auth.loginOTPVerify(payload).subscribe({
      next: (res: any) => {
        this.showFullLoader = false;
        if (!res?.data) {
          return;
        }
        this.afterLogin(res);
        this.closeAllDialog();
      },
      error: (err: any) => {
        this.showFullLoader = false;
      }
    });
  }

  callMe() {
    this.showFullLoader = true;
    this.auth.getUserProfile().subscribe({
      next: (res: any) => {
        const user = this.auth.setLastOrderInfo(res.data);
        this.util.setUserData(user);
        this.vars.userData.next(user);
        this.events.userGTMEvents({
          event: 'account',
          event_category: 'account',
          event_action: this.vars.loginType,
          event_label: user?.entity_type
        });
        this.showFullLoader = false;
      },
      error: (err: any) => { }
    });
  }

  registerUser() {
    this.vars.loginType = 'signup';
    const { name, email } = this.formFields;
    const payload = {
      accessToken: this.firebaseRes?.accessToken,
      email_id: email.value,
      extension: this.firebaseRes?.extension,
      firebase_response: this.firebaseRes?.firebase_response,
      full_name: name.value,
      // 'g-recaptcha-response':firebaseRes?.accessToken,
      invisible_recaptcha: true,
      is_subscribed: '1',
      password: 'Ketto@123',
      phone_1: this.firebaseRes?.phone,
      registration_source: 'direct',
      user_type: 'individual'
    }
    // console.log(payload);
    this.showFullLoader = true;
    this.auth.register(payload, true).subscribe({
      next: (res: any) => {
        this.afterLogin(res);
      },
      error: (err: any) => {
        this.showFullLoader = false;
        if (err?.error?.message?.match('already been taken')) {
          this.alreadyExistEmails.push(email.value);
        }
      }
    });
  }

  afterLogin(res) {
    res['data']['user']['isLoggedIn'] = true;
    this.util.setUser(res?.data);
    this.sendLeadStepZero();
    this.callMe();
  }

  sendLeadStepZero() {
    const { name, email } = this.formFields;
    const leadPayload: ILeadPayload = {
      about: 'Start a fundraiser',
      // cause: 'medical',
      email: email.value,
      name: name.value,
      // page: 'signup',
      query_type: 'want_to_raise_funds',
      subject: 'SAC signup-You received a new lead',
      type: 'P - SAF Step 0',
      alloMultiLead: true
    }
    this.sendLead.emit(leadPayload);
  }

  // For Start Fundraiser CTA
  startFundraiserMethod() {
    if (this.formGroup.valid) {
      this.startFundraiser.emit();
    } else {
      this.formGroup.markAllAsTouched();
      this.focusFirstInvalidField();
      // console.log('Form Data:', this.formGroup.value, this.formGroup.errors);
    }
  }
}
